import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import SpedNotesComponent from './spedNotes/components/SpedNotesComponent';

const SpedNotes = () => {
  return renderComponent(<SpedNotesComponent />);
};

export default SpedNotes;
